import React from "react";
import TabelaProdap from "features/shared/components/TabelaProdap";
import { tableStyles } from "./tableStyle";
import { withStyles } from "@material-ui/core";
import { formatBRL } from "../utils";
import { useTranslations, Trans } from "adapters/i18n";
import { BannerAlert } from "features/shared/components";

function PlanningCategoryReportTable({
  planningCategoryReport,
  periodTitles,
  classes,
}) {
  const { t } = useTranslations();

  const planningCategoryReportTableViewColumns = () => {
    const periodColumns = periodTitles.map((month, monthIndex) => ({
      id: month,
      titulo: month,
      ordenavel: false,
      pegaValor: (report) => (
        <span className={report.category ? "" : classes.cellItemBold}>
          {formatBRL(report.months[monthIndex] || 0)}
        </span>
      ),
    }));

    return [
      {
        id: "category",
        titulo: t("animalCategory:category"),
        ordenavel: false,
        pegaValor: (report) =>
          report.category ? (
            <span>{report.category.name}</span>
          ) : (
            <span className={classes.cellItemBold}>
              {t("planning:report.weighted-average")}
            </span>
          ),
      },
      ...periodColumns,
      {
        id: "total",
        titulo: t("common:total-year"),
        ordenavel: false,
        pegaValor: (report) =>
          report.category ? (
            <span className={classes.cellItemBold}>
              {formatBRL(report.total || 0)}
            </span>
          ) : (
            <></>
          ),
      },
    ];
  };
  const itemsWithTotal = planningCategoryReport
    ? [
        ...planningCategoryReport.categories,
        planningCategoryReport.weightedAverage,
      ]
    : [];

  return (
    <div className={classes.container}>
      <h1 className={classes.tableTitle}>
        {t("planning:report.category-title")}
      </h1>
      <div
        className={`${classes.tableContent} ${classes.categoryReportTableContent}`}
        data-testId="Plannings-Category-Report-Table"
      >
        <TabelaProdap
          className={classes.tableContainer}
          idCabecalhoTabela={"planningCategoryReportTableHead"}
          colunas={planningCategoryReportTableViewColumns()}
          ativarPaginacao={false}
          linhas={itemsWithTotal}
          tabelaEsquerda={true}
          noPaper
        />
      </div>
      <BannerAlert className={classes.disclaimer} type="plain">
        <Trans
          i18nKey="planning:report.disclimer-month-cost"
          components={{ b: <b /> }}
        />
      </BannerAlert>
      <BannerAlert className={classes.disclaimer} type="plain">
        <Trans
          i18nKey="planning:report.disclimer-weighted-average"
          components={{ b: <b /> }}
        />
      </BannerAlert>
    </div>
  );
}

const style = (theme) => ({
  ...tableStyles(theme),
  categoryReportTableContent: {
    "& table": {
      "& tbody > tr:last-child": {
        background: "#fafafa",
        borderTop: "16px solid #fff",
      },
      "& tbody > tr:last-child:hover": {
        background: "#fafafa !important",
      },
    },
  },
  disclaimer: {
    marginTop: "12px",
  },
});

export default withStyles(style)(PlanningCategoryReportTable);
